import { Select } from "antd";

import { RVFormFloatingLabelWrap } from "@regal-voice/ui";

import type { TaskAttributesTitle } from "@regal-voice/shared-types";

import styles from "../CancelTaskFormItems.module.scss";

const taskTitles: TaskAttributesTitle[] = [
    "Inbound SMS",
    "Outbound SMS",
    "Inbound Email",
    "Incoming Call",
    "Outbound Call",
    "ASAP Callback",
    "Scheduled Callback",
    "Voicemail",
    "Custom Task",
    "Reminder",
];

export function CancelTaskTypeFormItems(): JSX.Element {
    return (
        <>
            <RVFormFloatingLabelWrap
                name="taskType"
                label="Type"
                extra={
                    <span className={styles.infoSpan}>
                        For a given contact, cancels all tasks from the queue with the specified task type.
                    </span>
                }
                rules={[
                    {
                        required: true,
                        message: "Select Task Type.",
                    },
                ]}
            >
                <Select>
                    {taskTitles.map((x) => (
                        <Select.Option key={x} value={x}>
                            {x}
                        </Select.Option>
                    ))}
                </Select>
            </RVFormFloatingLabelWrap>
        </>
    );
}
